"use client";

import React from "react";
import { IconBoxGrid } from "./icon-box-grid";
import { cn } from "../../lib/utils";
import { RenderMarkdown } from "../render-markdown";

interface IconBoxGridSectionProps {
  title: string;
  description: string;
  features: {
    heading: string;
    description: string;
    image: any;
  }[];
  hasBackground?: boolean;
}

export const IconBoxGridSection = ({
  title,
  description,
  features,
  hasBackground,
}: IconBoxGridSectionProps) => {
  return (
    <section
      className={cn(
        " my-14 lg:my-28 w-full h-full",
        hasBackground && "bg-[#f6f6f6] py-14 lg:py-28"
      )}
    >
      <div className="w-full max-w-7xl mx-auto px-4">
        <div>
          <div className="flex flex-col gap-4 mb-10">
            <h2 className="text-2xl lg:text-4xl font-bold text-center md:max-w-[50%] mx-auto">
              {title}
            </h2>
            <div className="text-muted-foreground text-sm lg:text-base text-center">
              <RenderMarkdown>{description}</RenderMarkdown>
            </div>
          </div>
          <div>
            <IconBoxGrid features={features} />
          </div>
        </div>
      </div>
    </section>
  );
};
